
























import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import UserMixin from '@/Shared/UserMixin';
import HostedCheckoutRequestUserEntry from '@/Payment/HostedCheckoutRequestUserEntry';
import KeyValuePairGrid from '@/Shared/KeyValuePairGrid.vue';
import ReleaseCompletion from '@/Citation/Payment/ReleaseCompletion.vue';
import Five9CreditHoldCompletion from '@/Citation/Payment/Five9CreditHoldCompletion.vue';
import { Logger } from '@/Shared/Logger';
import VatsAPI from '@/Shared/VatsAPI';
import { PaymentResult } from '@/Payment/PaymentResult';

const component = mixins(LocationBasedMixin, UserMixin).extend({
    name: 'Five9BootRelease',
    components: {
        KeyValuePairGrid,
        ReleaseCompletion,
        Five9CreditHoldCompletion
    },
    props: {
        hostedCheckoutRequest: {
            type: Object as () => HostedCheckoutRequestUserEntry,
            required: true
        }
    },
    computed: {
        holdRequestID(): string {
            return (this.hostedCheckoutRequest as HostedCheckoutRequestUserEntry)
                .properties.find(prop => prop.key === 'holdRequestID')?.value ?? '';
        }
    },
    data() {
        return {
            i18nPrefix: 'payment.citationPayment.bootRelease.request',
            holdComplete: false,
            responseID: '',
            receiptId: 0
        };
    },
    methods: {
        async holdSuccess(result: string) {
            this.responseID = result;

            this.receiptId =
                (await VatsAPI.get<PaymentResult>(`${this.location}/Payments/ProcessorResponse/${this.responseID}`))
                    .data.receiptId!;

            this.holdComplete = true;
        }
    }
});

export default component;
